import React from 'react';

export const SvgDeleteForever = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.79 3.29l.71.71H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 011.41 0L12 12.59l1.42-1.42a.996.996 0 111.41 1.41L13.41 14l1.42 1.42a.996.996 0 11-1.41 1.41L12 15.41l-1.42 1.42a.996.996 0 11-1.41-1.41L10.59 14l-1.42-1.42a.996.996 0 010-1.41z"
      fill="currentColor"
    />
  </svg>
);
